/**
 * 매장 상세 섹션 스크롤 ref 및 스크롤 이동.
 * store page 전용 hook.
 */
import { useRef, useCallback } from "react";

export type StoreSection = "reserve" | "timeSale" | "review";

export function useStoreScroll() {
  const reserveRef = useRef<HTMLDivElement>(null);
  const timeSaleRef = useRef<HTMLDivElement>(null);
  const reviewRef = useRef<HTMLDivElement>(null);

  const scrollToSection = useCallback((section: StoreSection) => {
    const refs = {
      reserve: reserveRef,
      timeSale: timeSaleRef,
      review: reviewRef,
    };
    const targetRef = refs[section];
    if (targetRef.current) {
      targetRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, []);

  return {
    reserveRef,
    timeSaleRef,
    reviewRef,
    scrollToSection,
  };
}
